var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M379.3,370.7H120.7c-6.8,0-12.4-5.5-12.4-12.4c0-2.3,0.7-4.6,1.9-6.6c22.8-37,34.2-79.6,33-123.1l-0.7-25.7 c0-28.8,11.2-55.8,31.5-76.1c20.3-20.3,47.3-31.5,75.9-31.5c28.6,0,55.5,11.2,75.9,31.5c20.3,20.3,31.5,47.3,31.5,75.9l-0.7,25.9 c-1.2,43.5,10.3,86.1,33.1,123.2c1.2,1.8,1.8,4.1,1.8,6.5C391.7,365.1,386.1,370.7,379.3,370.7z M376.6,360 C376.6,360,376.6,360.1,376.6,360C376.6,360.1,376.6,360,376.6,360z M123.5,359.9C123.4,359.9,123.4,360,123.5,359.9 C123.4,360,123.4,359.9,123.5,359.9z M126.3,355.1h247.3c-22.5-38.6-33.7-82.3-32.5-126.9l0.7-25.7c0-24.2-9.6-47.3-27-64.7 c-17.4-17.4-40.4-27-64.9-27s-47.5,9.6-64.9,27c-17.4,17.4-27,40.4-27,64.9l0.7,25.5C160,272.8,148.8,316.6,126.3,355.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M250,404.7c-23.8,0-43.1-19.3-43.1-43.1h15.6c0,15.2,12.4,27.5,27.5,27.5s27.5-12.4,27.5-27.5h15.6 C293.1,385.4,273.8,404.7,250,404.7z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.71cee2c185f0671c4411f3ad1a6b717a.svg";
export { ForwardRef as ReactComponent };